import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import LabTile from '../components/LabTile';
import Data from '../data/LabsData';

const Labs = (props) => {
  const labIds = Object.keys(Data);

  return (
    <>
      <Container maxWidth='lg' sx={{ py: { xs: 3, md: 5 } }}>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          <Typography variant='h1' component='h1'>Labs</Typography>

        </Box>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 18rem), 1fr))',
            gap: 2.5,
            alignItems: 'stretch',
          }}
        >
          {labIds.map((labId) => {
            // Note: This is not a sorted list
            return (
              <LabTile
                key={labId}
                labId={labId}
                lab={Data[labId].name}
                description={Data[labId].description}
                imageFileName={Data[labId].imageFileName}
                imageAlt={Data[labId].imageAlt}
                tags={Data[labId].tags}
                status={Data[labId].status}
              />
            );
          })}
        </Box>
      </Container>
    </>
  );
};

export default Labs;
